// @flow
import * as React from 'react';
import { translate } from 'react-i18next';
import styled from 'styled-components';
import RaisedButton from 'material-ui/RaisedButton/RaisedButton';

import FolloDialog from 'advertisers/components/FolloDialog';

const Wrapper = styled.div`
  padding:  ${({ theme }) => theme.metrics.margin}px ${({ theme }) => theme.metrics.largeMargin}px;
`;

const Message = styled.div`
`;

const Footer = styled.div`
  margin-top: ${({ theme }) => theme.metrics.margin}px;
  
  width: 100%;
  display: flex;
  
  align-items: center;
  justify-content: center;
`;

interface Props {
  open: boolean;
  onClose: () => void;

  t: any;
}

function FolloSignupWithStatsRadioDialog({ open, onClose, t }: Props) {
  return (
    <FolloDialog
      title={t('statsRadioAccountPresent')}
      visible={open}
      onClose={onClose}
    >
      <Wrapper>
        <Message>
          {t('statsRadioAccountPresentMessage')}
        </Message>
        <Footer>
          <RaisedButton primary label="Ok" onClick={onClose} />
        </Footer>
      </Wrapper>
    </FolloDialog>
  );
}

export default translate('signup')(FolloSignupWithStatsRadioDialog);



// WEBPACK FOOTER //
// ./src/advertisers/modules/signup/components/FolloSignupWithStatsRadioDialog.js